import React from 'react';

const WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

// Optional per-provider schedule. The LiveKit agent turns this into a
// deterministic OPEN/CLOSED fact appended to the system prompt at call
// start - the practice's own prompt decides what to do with that fact
// (e.g. follow a different, after-hours section). Leaving every field
// blank means no status is ever reported, matching behavior before this
// existed.
export const BusinessHoursPicker = ({
  days,
  onDaysChange,
  startTime,
  onStartTimeChange,
  endTime,
  onEndTimeChange,
}) => {
  const toggleDay = (day) => {
    onDaysChange(
      days.includes(day) ? days.filter((d) => d !== day) : [...days, day]
    );
  };

  return (
    <div className="mb-3">
      <label className="text-white form-label mb-1 d-block">
        Business Hours (optional)
      </label>
      <div className="text-white-50 small mb-2">
        The AI will know whether it's currently within these hours and can
        follow different instructions in your prompt accordingly. Leave
        everything blank if this doesn't apply.
      </div>
      <div className="mb-2">
        {WEEKDAYS.map((day) => (
          <div className="form-check form-check-inline" key={day}>
            <input
              type="checkbox"
              className="form-check-input"
              id={`business_hours_day_${day}`}
              checked={days.includes(day)}
              onChange={() => toggleDay(day)}
            />
            <label
              className="form-check-label text-white"
              htmlFor={`business_hours_day_${day}`}
            >
              {day.slice(0, 3)}
            </label>
          </div>
        ))}
      </div>
      <div className="row g-2">
        <div className="col-6">
          <input
            type="time"
            className="bg-black border-0 text-white py-2 px-3 form-control"
            aria-label="Business hours start time"
            value={startTime}
            onChange={(e) => onStartTimeChange(e.target.value)}
          />
        </div>
        <div className="col-6">
          <input
            type="time"
            className="bg-black border-0 text-white py-2 px-3 form-control"
            aria-label="Business hours end time"
            value={endTime}
            onChange={(e) => onEndTimeChange(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};
